import axios from "axios";
import { authHeaderJson } from "./auth-header.service";




const getAllProfiles = () => {
  return axios.post(`/api/role-auth/get-all`, null, { headers: authHeaderJson() } );
};



export default {
  getAllProfiles
};